/**
 * SPハンバーガーメニュー（2026-08 改修）
 * 開閉そのものは theme.js の Drawer 機構が担う。このファイルは3つだけ:
 *   1. 開く直前にヘッダー下端を実測して --sbm-top をセット
 *      （帯バナーはアプリ(Hextom)がJSで挿入するため高さを実測でしか取れない）
 *   2. 開いている間、html に .sbm-open を付与し、ハンバーガーの
 *      data-action を close-drawer に書き換える（→ theme.js がそのまま閉じる）
 *   3. PC幅へのリサイズ時に強制クローズ（no-scroll が残る事故の防止）
 */
(function () {
  var drawer = document.getElementById('sidebar-menu');
  if (!drawer) return;

  var html = document.documentElement;
  var DESK_MIN_WIDTH = 1140; // theme.css の .hidden-desk と同じ切替点

  function headerElement() {
    return document.querySelector('#shopify-section-header .Header') ||
      document.getElementById('shopify-section-header');
  }

  function isOpen() {
    return drawer.getAttribute('aria-hidden') === 'false';
  }

  function setTop() {
    var header = headerElement();
    if (!header) return;
    var bottom = Math.max(0, header.getBoundingClientRect().bottom);
    html.style.setProperty('--sbm-top', bottom + 'px');
  }

  function toggleButtons(open) {
    var buttons = document.querySelectorAll('[data-drawer-id="sidebar-menu"][data-action]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.closest('.Drawer')) continue; // ドロワー内部のボタンは対象外
      btn.setAttribute('data-action', open ? 'close-drawer' : 'open-drawer');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    }
  }

  function sync() {
    var open = isOpen();
    html.classList.toggle('sbm-open', open);
    toggleButtons(open);
    if (open) {
      // ESCで閉じるにはドロワー自身にフォーカスが要る（theme.jsのkeyupリスナーはドロワー要素上）。
      // aria-hidden変更直後はスタイル再計算前で computed visibility が hidden のままになり
      // focus() が無言で失敗するため、再計算後まで遅延させる
      window.setTimeout(function () {
        if (isOpen()) drawer.focus({ preventScroll: true });
      }, 100);
    }
  }

  function forceClose() {
    var closeBtn = document.querySelector('[data-action="close-drawer"][data-drawer-id="sidebar-menu"]');
    if (closeBtn) closeBtn.click(); // theme.js の委譲リスナーが close() を実行する
  }

  // 開くクリックのキャプチャ段階（= theme.js の open より先）で位置を確定させる
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]')) {
      setTop();
    }
  }, true);

  // 開閉状態は aria-hidden の変化で追う（ESC・暗幕クリックなど全ての閉じ方を拾える）
  new MutationObserver(sync).observe(drawer, {
    attributes: true,
    attributeFilter: ['aria-hidden']
  });

  window.addEventListener('resize', function () {
    if (!isOpen()) return;
    if (window.innerWidth >= DESK_MIN_WIDTH) {
      forceClose();
    } else {
      setTop();
    }
  });
})();
